"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maximizeLinkedInNavigator = exports.minimizeLinkedInNavigator = exports.hideLinkedInNavigator = exports.showLinkedInNavigator = void 0;

var _Dispatch = require("crm_data/dispatch/Dispatch");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var showLinkedInNavigator = function showLinkedInNavigator() {
  (0, _Dispatch.dispatchImmediate)(_ActionTypes.HIDE_LINKED_IN_NAVIGATOR);
  (0, _Dispatch.dispatchQueue)(_ActionTypes.SHOW_LINKED_IN_NAVIGATOR);
};

exports.showLinkedInNavigator = showLinkedInNavigator;

var hideLinkedInNavigator = function hideLinkedInNavigator() {
  (0, _Dispatch.dispatchImmediate)(_ActionTypes.HIDE_LINKED_IN_NAVIGATOR);
};

exports.hideLinkedInNavigator = hideLinkedInNavigator;

var minimizeLinkedInNavigator = function minimizeLinkedInNavigator() {
  (0, _Dispatch.dispatchImmediate)(_ActionTypes.MINIMIZE_LINKED_IN_NAVIGATOR);
};

exports.minimizeLinkedInNavigator = minimizeLinkedInNavigator;

var maximizeLinkedInNavigator = function maximizeLinkedInNavigator() {
  (0, _Dispatch.dispatchImmediate)(_ActionTypes.MAXIMIZE_LINKED_IN_NAVIGATOR);
};

exports.maximizeLinkedInNavigator = maximizeLinkedInNavigator;